import { defineStore } from "pinia";
import { ref } from "vue";
import { useTransition } from "@vueuse/core";
import api from "../modules/api";

const SIDEBAR_ANIMATE_DURATION = 50;
const GLOBAL_LEFT_SIDEBAR_WIDTH = 220;
const GLOBAL_RIGHT_SIDEBAR_WIDTH = 320;

const currentGlobalRightSidebarWidth = ref(GLOBAL_RIGHT_SIDEBAR_WIDTH);

const currentGlobalWindowHeight = ref(window.innerHeight);
const currentGlobalWindowWidth = ref(window.innerWidth);

const contentHeaderHeight = 46;
const isMobile = currentGlobalWindowWidth.value < 768;

let currentGlobalLeftSidebarOffset = 0;

if (isMobile) {
  currentGlobalLeftSidebarOffset = ref(GLOBAL_LEFT_SIDEBAR_WIDTH + 150);
} else {
  currentGlobalLeftSidebarOffset = ref(0);
}

export const useGlobalWindow = defineStore("globalWindow", {
  state: () => {
    return {
      showLeftSidebar: true,
      isMobile,
      showLoading: true,
      userInfo: {},
      isLoginDialogVisible: false,

      showRightSidebar: false,
      currentGlobalWindowHeight,
      contentHeaderHeight,
      showIntroWindow: false,

      showMainContent: true,
      unreadNum: 0,

      showReviews: true,

      leftSidebarOffset: useTransition(currentGlobalLeftSidebarOffset, {
        SIDEBAR_ANIMATE_DURATION,
        transition: [0.15, 1, 0.15, 1],
      }),

      rightSideBarWidth: useTransition(currentGlobalRightSidebarWidth, {
        SIDEBAR_ANIMATE_DURATION,
        transition: [0.15, 1, 0.15, 1],
      }),
    };
  },
  getters: {
    getUserInfo(state) {
      return state.userInfo;
    },
  },
  actions: {
    switchGlobalLeftSidebar() {
      if (this.showLeftSidebar == true) {
        currentGlobalLeftSidebarOffset.value = GLOBAL_LEFT_SIDEBAR_WIDTH + 150;
        setTimeout(() => {
          this.showLeftSidebar = false;
        }, SIDEBAR_ANIMATE_DURATION);
      } else {
        currentGlobalLeftSidebarOffset.value = 0;
        this.showLeftSidebar = true;
      }
    },
    switchGlobalRightSidebar() {
      if (currentGlobalRightSidebarWidth.value === GLOBAL_RIGHT_SIDEBAR_WIDTH) {
        currentGlobalRightSidebarWidth.value = 0;
        setTimeout(() => {
          this.showRightSidebar = false;
        }, SIDEBAR_ANIMATE_DURATION + 300);
      } else {
        currentGlobalRightSidebarWidth.value = GLOBAL_RIGHT_SIDEBAR_WIDTH;
        this.showRightSidebar = true;
      }
    },
    showLoginDialog(visible) {
      this.isLoginDialogVisible = visible;
    },
  },
});
